import React from 'react'
import styled from 'styled-components'
import {
  WishlistButton as WishlistButtonWrapper,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'
import { IconFavorites } from '../Icons'
import { Config } from '../../../config'

export const WishlistButton = ({
  productId,
  variantId,
  color = Config.palette.silverTree,
}: {
  productId: string
  variantId: string
  color?: string
}) => {
  const { addToWishlist } = useGlobalLabels()
  return (
    <WishlistButtonWrapper productId={productId} variantId={variantId}>
      <Container type="button" aria-label={addToWishlist} colorToUse={color}>
        <IconFavorites />
      </Container>
    </WishlistButtonWrapper>
  )
}

const Container = styled.button<{ isFavorite?: boolean; colorToUse: string }>`
  background: transparent;
  color: ${({ isFavorite, colorToUse, theme }) =>
    isFavorite ? theme.palette.burntSienna : colorToUse};

  & path {
    fill: ${(props) =>
      props.theme.palette[props.isFavorite ? 'burntSienna' : 'secondary']};
  }

  &:hover {
    background: transparent;
  }
`
